import React from "react";
import Chart from "react-apexcharts";
import { ClockIcon } from "@heroicons/react/24/solid";
import TopBotUsersChart from "../components/charts/TopBotUsersChart"
import HourlyMsgCountChart from "../components/charts/HourlyMsgCountChart"
import DailyMsgCountChart from "../components/charts/DailyMsgCountChart"
import ChartWithSkeleton from "./skeleton/ChartWithSkeleton"
export default function StatisticsCharts({ loadingDay, loadingHour, messagePerDaychartDate, messagePerHourChart, topUsersData, loading,
   isLoadingAllCharts}) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-y-12 gap-x-6 md:grid-cols-2 xl:grid-cols-3">
      {/* {data.map((props) => (
        <div key={props.title} className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className={`p-0`}>
            <Chart {...props.chart} />
          </div>
          <div className="px-6 pt-4">
            <p className="text-gray-800 font-semibold">{props.title}</p>
            <p className="text-gray-600 text-sm">{props.description}</p>
          </div>
          <div className="px-6 py-4 border-t border-gray-100 text-sm text-gray-600 flex items-center gap-1">
            <ClockIcon className="w-4 h-4 text-gray-400" /> {props.footer}
          </div>
        </div>
      ))} */}



      {isLoadingAllCharts ? (
        // <p className="text-gray-500 text-center py-5">در حال بارگذاری...</p>
        <>
          <ChartWithSkeleton type="line" width={400} height={250} />
          <ChartWithSkeleton type="line" width={400} height={250} />
          <ChartWithSkeleton type="bar" width={400} height={250} />
        </>
      ) : (
        <>
          <HourlyMsgCountChart messagePerHourChart={messagePerHourChart} />
          <DailyMsgCountChart messagePerDaychartDate={messagePerDaychartDate} />
          <TopBotUsersChart topUsersData={topUsersData} />
        </>
      )}


      {/*    
      {loadingHour || !messagePerHourChart?.length ? (
        <ChartWithSkeleton type="line" width={400} height={250} />
      ) : (
        <HourlyMsgCountChart messagePerHourChart={messagePerHourChart} />
      )}

     
      {loadingDay || !messagePerDaychartDate?.length ? (
        <ChartWithSkeleton type="line" width={400} height={250} />
      ) : (
        <DailyMsgCountChart messagePerDaychartDate={messagePerDaychartDate} />
      )}


      {loading || !topUsersData?.length ? (
        <ChartWithSkeleton type="bar" width={400} height={250} />
      ) : (
        <TopBotUsersChart topUsersData={topUsersData} />
      )} */}

    </div>
  );
}
